/* Página de produto — mesma lógica de produto.html, dados via IMG_PDP (Liquid) */
(function () {
  'use strict';

  var CFG = window.IMG_PDP || {};
  var SABORES = CFG.sabores || {};
  var DOSES_POR_POTE = CFG.dosesPorPote || 30;
  var PARCELAS = 3;
  var ehKit = CFG.tipo === 'kit';
  var GALERIA_FIXA = null;

  function urlsPipeParaLista(raw) {
    if (!raw) return [];
    return raw.split('|').map(function (u) { return u.trim(); }).filter(Boolean);
  }

  function lerGaleriaFixa() {
    if (GALERIA_FIXA) return GALERIA_FIXA;
    var wrap = document.getElementById('pdp-miniaturas');
    if (wrap) {
      var morango = urlsPipeParaLista(wrap.getAttribute('data-galeria-morango'));
      var uva = urlsPipeParaLista(wrap.getAttribute('data-galeria-uva-verde'));
      if (morango.length && uva.length) {
        GALERIA_FIXA = { morango: morango, 'uva-verde': uva };
        return GALERIA_FIXA;
      }
    }
    var el = document.getElementById('pdp-galeria-fixa-json');
    if (el) {
      try {
        GALERIA_FIXA = JSON.parse(el.textContent || '{}');
        return GALERIA_FIXA;
      } catch (e) { /* fallback abaixo */ }
    }
    GALERIA_FIXA = {};
    return GALERIA_FIXA;
  }

  function definirFotoPalco(foto, url) {
    if (!foto || !url) return;
    foto.removeAttribute('srcset');
    foto.removeAttribute('sizes');
    foto.src = url;
  }

  function indicesFotoNivel() {
    var wrap = document.getElementById('pdp-miniaturas');
    if (wrap && wrap.getAttribute('data-pdp-foto-nivel')) {
      return wrap.getAttribute('data-pdp-foto-nivel').split('|').map(function (x) {
        return parseInt(x, 10);
      });
    }
    return [0, 2, 5];
  }

  function urlFotoPorNivelAtual() {
    if (ehKit) return null;
    var galerias = lerGaleriaFixa();
    var lista = galerias[sabor];
    if (!lista || !lista.length) {
      var s = SABORES[sabor];
      return (s && s.foto) || null;
    }
    var idxs = indicesFotoNivel();
    var idx = idxs[nivel];
    if (idx == null || isNaN(idx) || idx < 0 || idx >= lista.length) idx = 0;
    return lista[idx];
  }

  function aplicarFotoPorNivel() {
    if (ehKit) return;
    var url = urlFotoPorNivelAtual();
    var foto = document.getElementById('pdp-foto');
    if (!url || !foto) return;
    definirFotoPalco(foto, url);
    var wrap = document.getElementById('pdp-miniaturas');
    if (!wrap) return;
    var btn = null;
    wrap.querySelectorAll('.mini').forEach(function (b) {
      if (b.getAttribute('data-foto') === url) btn = b;
    });
    if (btn) marcarMini(btn);
  }

  function aoClicarMiniatura(btn) {
    if (!btn) return;
    var f = btn.getAttribute('data-foto');
    var foto = document.getElementById('pdp-foto');
    if (!f || !foto) return;
    definirFotoPalco(foto, f);
    marcarMini(btn);
  }

  function ligarGaleriaMiniaturas() {
    var wrap = document.getElementById('pdp-miniaturas');
    if (!wrap || wrap.dataset.pdpMiniLigada === '1') return;
    wrap.dataset.pdpMiniLigada = '1';
    wrap.addEventListener('click', function (ev) {
      var btn = ev.target.closest('button.mini');
      if (!btn || !wrap.contains(btn)) return;
      ev.preventDefault();
      aoClicarMiniatura(btn);
    });
  }

  function montarGaleriaFixa(saborAtivo) {
    if (ehKit) return;
    var wrap = document.getElementById('pdp-miniaturas');
    var foto = document.getElementById('pdp-foto');
    if (!wrap || !foto) return;
    var galerias = lerGaleriaFixa();
    var lista = galerias[saborAtivo];
    if (!lista || !lista.length) {
      var s = SABORES[saborAtivo];
      if (s && s.foto) lista = [s.foto];
    }
    if (!lista || !lista.length) return;

    wrap.textContent = '';
    lista.forEach(function (url) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mini';
      btn.setAttribute('data-foto', url);
      btn.setAttribute('aria-pressed', 'false');
      var thumb = document.createElement('img');
      thumb.src = url;
      thumb.alt = '';
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      btn.appendChild(thumb);
      wrap.appendChild(btn);
    });

    var saborCfg = SABORES[saborAtivo];
    if (saborCfg && saborCfg.alt) foto.alt = saborCfg.alt;
    aplicarFotoPorNivel();
    atualizarQueryPdp();
  }

  function cfgPagamentoShopify() {
    var shop = window.IMG_SHOPIFY || {};
    return shop.promoDuo || {};
  }

  function textoParcelaPix() {
    var promo = cfgPagamentoShopify();
    var parcelas = typeof promo.parcelasCartao === 'number' ? promo.parcelasCartao : PARCELAS;
    var pct = typeof promo.percentualPixCheckout === 'number' ? promo.percentualPixCheckout : 0.05;
    return 'Em até ' + parcelas + 'x sem juros ou ' + Math.round(pct * 100) + '% de desconto no PIX';
  }

  function tituloProdutoPagina() {
    if (ehKit) {
      return (CFG.kit && CFG.kit.nome) || CFG.tituloKit || CFG.tituloProduto || '';
    }
    return CFG.tituloCreatina || CFG.tituloProduto || '';
  }

  function linhaDosesPagina() {
    if (ehKit) {
      var k = CFG.kit || {};
      return k.dosesLinha || ('60 doses · morango + uva verde');
    }
    var s = SABORES[sabor];
    if (!s) return '';
    if (s.dosesLinha) return s.dosesLinha;
    var rot = (s.rotulo || '').toLowerCase();
    return DOSES_POR_POTE + ' doses · ' + rot;
  }

  var NOTAS = ['1 mês de ritual', '2 meses de ritual', '3 meses de ritual'];
  var NIVEIS = [];

  function pctPromoDuo() {
    var p = (CFG.shopify && CFG.shopify.promoDuo) || (window.IMG_SHOPIFY && window.IMG_SHOPIFY.promoDuo) || {};
    return typeof p.percentual === 'number' ? p.percentual : 0.1;
  }

  function referenciaDuasUnidadesCent() {
    var keys = chavesSabores();
    var soma = 0;
    keys.forEach(function (k) {
      soma += (SABORES[k] && SABORES[k].precoCentavos) || 0;
    });
    if (soma > 0 && keys.length >= 2) return soma;
    if (soma > 0 && keys.length === 1) return soma * 2;
    return 0;
  }

  function montarNiveis(unitCent) {
    var pct = pctPromoDuo();
    var refDuas = referenciaDuasUnidadesCent();

    if (ehKit) {
      var k = CFG.kit || {};
      var cheio = refDuas || k.compararCentavos || 0;
      if (cheio <= 0) cheio = k.precoCentavos || unitCent || 0;
      var precoKit = Math.round(cheio * (1 - pct));
      if (precoKit <= 0) precoKit = k.precoCentavos || unitCent || 0;
      return [{
        qtd: 1,
        sku: 'kit',
        precoCentavos: precoKit,
        cheioCentavos: cheio,
        rotulo: '1 kit',
        nota: 'Os dois sabores'
      }];
    }
    var s = SABORES[sabor] || {};
    var comparar = s.compararCentavos;
    var cheio1 = comparar && comparar > unitCent ? comparar : unitCent;
    var cheioKitMisto = refDuas || unitCent * 2;
    var precoKitMisto = Math.round(cheioKitMisto * (1 - pct));
    return [
      {
        qtd: 1,
        sku: sabor,
        precoCentavos: unitCent,
        cheioCentavos: cheio1,
        rotulo: '1 pote',
        nota: NOTAS[0]
      },
      {
        qtd: 2,
        sku: sabor,
        precoCentavos: Math.round(unitCent * 2 * (1 - pct)),
        cheioCentavos: unitCent * 2,
        rotulo: '2 potes',
        nota: NOTAS[1]
      },
      {
        qtd: 1,
        sku: 'kit',
        precoCentavos: precoKitMisto,
        cheioCentavos: cheioKitMisto,
        rotulo: 'Kit misto',
        nota: 'Morango + uva verde'
      }
    ];
  }

  function precoUnitarioCent() {
    if (ehKit) return (CFG.kit && CFG.kit.precoCentavos) || 0;
    var s = SABORES[sabor];
    return (s && s.precoCentavos) || 0;
  }

  function atualizarNiveis(){
    NIVEIS = montarNiveis(precoUnitarioCent());
    if (nivel >= NIVEIS.length) nivel = 0;
  }

  var sabor = 'morango';
  var nivel = 0;

  function moeda(v, casas) {
    return v.toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL',
      minimumFractionDigits: casas === undefined ? 0 : casas,
      maximumFractionDigits: casas === undefined ? 0 : casas
    });
  }

  function moedaCent(centavos, casas) {
    if (casas === undefined) casas = 2;
    return moeda((Number(centavos) || 0) / 100, casas);
  }

  function chavesSabores(){
    return Object.keys(SABORES);
  }

  function lerSaborDaURL() {
    if (ehKit) return null;
    var p = new URLSearchParams(location.search).get('sabor');
    if (p && SABORES[p]) return p;
    var vid = new URLSearchParams(location.search).get('variant');
    if (vid && CFG.variantParaSabor && CFG.variantParaSabor[vid]) return CFG.variantParaSabor[vid];
    var op = new URLSearchParams(location.search).get('opcao');
    if (op === 'kit-misto' || op === 'kit') return chavesSabores()[0] || 'morango';
    return chavesSabores()[0] || 'morango';
  }

  function nivelParaOpcao(i) {
    var map = ['1-pote', '2-potes', 'kit-misto'];
    return map[i] || map[0];
  }

  function opcaoParaNivel(raw) {
    if (raw == null || raw === '') return null;
    var op = String(raw).toLowerCase();
    if (op === 'kit-misto' || op === 'kit') return 2;
    if (op === '2-potes' || op === '2') return 1;
    if (op === '1-pote' || op === '1') return 0;
    var n = parseInt(op, 10);
    if (!isNaN(n) && n >= 0 && n < 3) return n;
    return null;
  }

  function lerNivelDaURL() {
    if (ehKit) return 0;
    var q = new URLSearchParams(location.search);
    var fromOpcao = opcaoParaNivel(q.get('opcao'));
    if (fromOpcao != null) return fromOpcao;
    fromOpcao = opcaoParaNivel(q.get('nivel'));
    if (fromOpcao != null) return fromOpcao;
    return 0;
  }

  function atualizarQueryPdp() {
    if (ehKit || !sabor) return;
    var url = new URL(location.href);
    url.searchParams.set('sabor', sabor);
    url.searchParams.set('opcao', nivelParaOpcao(nivel));
    if (nivel === 2) {
      var kit = CFG.catalogo && CFG.catalogo.kit;
      if (kit && kit.variant_id) url.searchParams.set('variant', String(kit.variant_id));
    } else {
      var s = SABORES[sabor];
      if (s && s.variant_id) url.searchParams.set('variant', String(s.variant_id));
    }
    history.replaceState(null, '', url.pathname + url.search);
  }

  function pintarSabor() {
    var titulo = tituloProdutoPagina();
    var elDoses = document.getElementById('pdp-doses');
    if (elDoses) elDoses.textContent = linhaDosesPagina();

    if (ehKit) {
      var k = CFG.kit;
      if (!k) return;
      var elNomeK = document.getElementById('pdp-nome');
      var elTagK = document.getElementById('pdp-tag');
      var elDescK = document.getElementById('pdp-desc');
      var elMigK = document.getElementById('migalha-atual');
      if (elNomeK) elNomeK.textContent = titulo;
      if (elTagK) elTagK.textContent = k.tag || 'Kit';
      if (elDescK) elDescK.textContent = k.desc || '';
      if (elMigK) elMigK.textContent = titulo;
      document.title = titulo + " | I'M GOODIES";
      var foto = document.getElementById('pdp-foto');
      if (foto) {
        definirFotoPalco(foto, k.foto);
        foto.alt = k.alt || titulo;
      }
      return;
    }

    var s = SABORES[sabor];
    if (!s) return;
    var elNome = document.getElementById('pdp-nome');
    var elTag = document.getElementById('pdp-tag');
    var elDesc = document.getElementById('pdp-desc');
    var elMig = document.getElementById('migalha-atual');
    if (elNome) elNome.textContent = titulo;
    if (elTag) elTag.textContent = s.tag || '';
    if (elDesc) elDesc.textContent = s.desc || '';
    if (elMig) elMig.textContent = titulo;
    document.title = titulo + " | I'M GOODIES";

    montarGaleriaFixa(sabor);

  }

  function marcarMini(ativa) {
    var wrap = document.getElementById('pdp-miniaturas');
    if (!wrap) return;
    wrap.querySelectorAll('.mini').forEach(function (b) {
      var e = b === ativa;
      b.classList.toggle('mini--ativa', e);
      b.setAttribute('aria-pressed', String(e));
    });
  }

  function pintarNiveis() {
    var alvo = document.getElementById('niveis');
    if (!alvo) return;
    var base = NIVEIS[0] ? NIVEIS[0].precoCentavos : 0;
    var html = '';
    NIVEIS.forEach(function (n, i) {
      var cheio = n.cheioCentavos != null ? n.cheioCentavos : base * n.qtd;
      var economia = cheio - n.precoCentavos;
      var pct = cheio > 0 ? Math.round((economia / cheio) * 100) : 0;
      html +=
        '<label class="nivel' + (i === nivel ? ' nivel--ativo' : '') + '">' +
        '<input type="radio" name="nivel" value="' + i + '"' + (i === nivel ? ' checked' : '') + '>' +
        '<span class="nivel__topo">' +
        '<span class="nivel__rotulo">' + n.rotulo + '</span>' +
        (economia > 50 ? '<span class="nivel__selo">−' + pct + '%</span>' : '') +
        '</span>' +
        '<span class="nivel__preco">' + moedaCent(n.precoCentavos) + '</span>' +
        '<span class="nivel__nota">' + n.nota +
        (economia > 50 ? ' · economiza ' + moedaCent(economia) : '') + '</span>' +
        '</label>';
    });
    alvo.innerHTML = html;
  }

  function marcarNivel() {
    var caixas = document.querySelectorAll('#niveis .nivel');
    for (var i = 0; i < caixas.length; i++) {
      caixas[i].classList.toggle('nivel--ativo', i === nivel);
    }
  }

  function pintarPreco() {
    var n = NIVEIS[nivel];
    if (!n) return;
    var valorEl = document.getElementById('pdp-valor');
    var deEl = document.getElementById('pdp-de');
    if (valorEl) valorEl.textContent = moedaCent(n.precoCentavos);
    if (deEl) {
      var cheio = n.cheioCentavos || n.precoCentavos;
      if (cheio > n.precoCentavos) {
        deEl.textContent = moedaCent(cheio);
        deEl.hidden = false;
      } else {
        deEl.hidden = true;
      }
    }
    var parcelaEl = document.getElementById('pdp-parcela');
    if (parcelaEl) parcelaEl.textContent = textoParcelaPix();
  }

  function skuAtual(){
    if (ehKit) return 'kit';
    var n = NIVEIS[nivel];
    if (n && n.sku) return n.sku;
    return sabor;
  }

  function varianteDaSelecao() {
    var cat = CFG.catalogo || {};
    var p = cat[skuAtual()];
    if (!p || !p.variant_id) return null;
    return p;
  }

  /* Mesma regra dos cards da home: sem "continue", estoque rastreado ≤ 0 vira Esgotado. */
  function podeComprarSelecao() {
    var p = varianteDaSelecao();
    if (!p) return false;
    if (!window.IMGCart || !window.IMGCart.maxStock) return true;
    return window.IMGCart.maxStock(p.variant_id) > 0;
  }

  function aplicarEstadoCompra() {
    var btn = document.getElementById('pdp-add');
    if (!btn) return;
    var p = varianteDaSelecao();
    if (!p) {
      btn.disabled = true;
      btn.textContent = 'Indisponível';
      return;
    }
    if (!podeComprarSelecao()) {
      btn.disabled = true;
      btn.textContent = 'Esgotado';
      return;
    }
    btn.disabled = false;
    btn.textContent = 'Comprar agora';
  }

  function adicionarAoCarrinho(sku, qtd){
    var cat = CFG.catalogo || {};
    var p = cat[sku];
    if (!p || !p.variant_id || !window.IMGCart) return;
    if (window.IMGCart.maxStock && window.IMGCart.maxStock(p.variant_id) <= 0) {
      aplicarEstadoCompra();
      return;
    }
    window.IMGCart.add(p.variant_id, qtd || 1, p.nome);
  }

  var pdpVideosProntos = false;

  function iniciarVideosPdp() {
    if (pdpVideosProntos) return;
    var modal = document.getElementById('pdp-modal-video');
    var player = document.getElementById('pdp-modal-video-player');
    if (!modal || !player) return;
    pdpVideosProntos = true;

    var ultimoGatilho = null;

    function pararVideo() {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }

    function fecharModal(devolverFoco) {
      modal.classList.remove('aberto');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      pararVideo();
      if (devolverFoco && ultimoGatilho) ultimoGatilho.focus();
    }

    function abrirModal(btn) {
      var src = btn.getAttribute('data-video-src') || '';
      if (!src) return;
      ultimoGatilho = btn;
      var poster = btn.getAttribute('data-poster') || '';
      player.poster = poster;
      player.src = src;
      modal.removeAttribute('hidden');
      modal.classList.add('aberto');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var fecharBtn = modal.querySelector('.pdp-modal-video__fechar');
      if (fecharBtn) fecharBtn.focus();
      var playPromise = player.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { /* autoplay bloqueado: controles nativos */ });
      }
    }

    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.pdp-video[data-video-src]');
      if (!btn) return;
      ev.preventDefault();
      ev.stopPropagation();
      abrirModal(btn);
    });

    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pdp-fechar-video]')) {
        ev.preventDefault();
        fecharModal(true);
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal.classList.contains('aberto')) {
        ev.preventDefault();
        fecharModal(true);
      }
    });
  }

  function ligar() {
    document.querySelectorAll('input[name="sabor"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        sabor = r.value;
        atualizarNiveis();
        pintarSabor();
        pintarNiveis();
        pintarPreco();
        aplicarEstadoCompra();
      });
    });

    var niveis = document.getElementById('niveis');
    if (niveis) {
      niveis.addEventListener('change', function (ev) {
        var r = ev.target.closest('input[name="nivel"]');
        if (!r) return;
        nivel = Number(r.value);
        marcarNivel();
        aplicarFotoPorNivel();
        atualizarQueryPdp();
        pintarPreco();
        aplicarEstadoCompra();
      });
    }

    var btnAdd = document.getElementById('pdp-add');
    if (btnAdd) {
      btnAdd.addEventListener('click', function () {
        if (btnAdd.disabled || !podeComprarSelecao()) return;
        var n = NIVEIS[nivel];
        var qtd = n ? n.qtd : 1;
        adicionarAoCarrinho(skuAtual(), qtd);
      });
    }

    if (window.IMGCart && window.IMGCart.subscribe) {
      window.IMGCart.subscribe(aplicarEstadoCompra);
    }

    var linkAvaliacoes = document.querySelector('.pdp__avaliacao-resumo');
    if (linkAvaliacoes) {
      linkAvaliacoes.addEventListener('click', function (ev) {
        var sec = document.getElementById('avaliacoes');
        if (!sec) return;
        ev.preventDefault();
        var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
        try {
          history.replaceState(null, '', '#avaliacoes');
        } catch (e) { /* ignore */ }
      });
    }

    document.addEventListener('click', function (ev) {
      var gatilho = ev.target.closest('.faq__gatilho');
      if (!gatilho) return;
      var aberto = gatilho.getAttribute('aria-expanded') === 'true';
      gatilho.setAttribute('aria-expanded', String(!aberto));
      var painel = document.getElementById(gatilho.getAttribute('aria-controls'));
      if (painel) painel.classList.toggle('aberta', !aberto);
    });
  }

  function iniciarTabelaComparativa() {
    var sec = document.querySelector('.tp');
    if (!sec) return;
    function ativar() {
      sec.classList.add('ativo');
    }
    var alvo = sec.querySelector('.tp__tabela');
    if (!alvo) {
      ativar();
      return;
    }
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              ativar();
              obs.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      obs.observe(alvo);
    } else {
      ativar();
    }
  }

  function iniciar() {
    iniciarVideosPdp();
    iniciarTabelaComparativa();
    ligarGaleriaMiniaturas();

    if (!ehKit) {
      sabor = lerSaborDaURL();
      nivel = lerNivelDaURL();
      var radio = document.querySelector('input[name="sabor"][value="' + sabor + '"]');
      if (radio) radio.checked = true;
    }

    atualizarNiveis();
    if (!ehKit && nivel >= NIVEIS.length) nivel = 0;
    pintarSabor();
    pintarNiveis();
    pintarPreco();
    ligar();
    aplicarEstadoCompra();
  }

  function bootPdp() {
    iniciarVideosPdp();
    iniciar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootPdp);
  else bootPdp();
})();
